const version = "2.3.9";

export { version };
//# sourceMappingURL=version.mjs.map
